module.exports = __webpack_public_path__ + "img/onyamalimba.cb8f02b5.png";